import CookieDisclaimer from './CookieDisclaimer';

export default CookieDisclaimer;
